module.exports = __webpack_public_path__ + "welcome-b211e3ad43f1115500ac7d2fc2c6004d.svg";